<template>
  <v-menu location="bottom end" min-width="220">
    <template #activator="{ props }">
      <app-button
        v-bind="props"
        type="icon"
        size="x-small"
        @click="() => emit('set-active-rectangle-id', rectangle.id)"
      >
        <app-icon-ds icon="ellipsis-h" size="xs" />
      </app-button>
    </template>

    <v-list>
      <v-list-item @click="() => emit('duplicate-on-all-pages', rectangle)">
        <template #prepend>
          <app-icon-ds icon="copy" size="sm" class="mr-2" />
        </template>
        <v-list-item-title>
          {{ t('common.PdfRedactingSidebar.duplicateAllPages') }}
        </v-list-item-title>
      </v-list-item>

      <DeletePopover
        v-if="shouldShowDeleteOnAllPages"
        :item="rectangle"
        :confirmation-text="t('common.PdfRedactingSidebar.deleteOnAllPagesConfirmation')"
        maxWidth="320"
        location="top right"
        @confirm="() => emit('delete-on-all-pages', rectangle)"
      >
        <template #trigger>
          <v-list-item class="cursor-pointer delete-rectangle-item">
            <template #prepend>
              <app-icon-ds icon="trash-can" size="sm" class="mr-2 text-error" />
            </template>
            <v-list-item-title>
              {{ t('common.PdfRedactingSidebar.deleteOnAllPages') }}
            </v-list-item-title>
          </v-list-item>
        </template>
      </DeletePopover>

      <DeletePopover
        :item="rectangle"
        location="top right"
        @confirm="() => emit('delete-rectangle', rectangle)"
      >
        <template #trigger>
          <v-list-item class="cursor-pointer delete-rectangle-item">
            <template #prepend>
              <app-icon-ds icon="trash-can" size="sm" class="mr-2 text-error" />
            </template>
            <v-list-item-title>
              {{ t('common.delete') }}
            </v-list-item-title>
          </v-list-item>
        </template>
      </DeletePopover>
    </v-list>
  </v-menu>
</template>

<script lang="ts" setup>
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import DeletePopover from '@/common/popover/DeletePopover.vue'

type Rectangle = {
  id: number
  page: number
  x: number
  y: number
  width: number
  height: number
  index: number
  isCopy?: boolean
}

const props = defineProps<{
  rectangle: Rectangle
  allRectangles: Rectangle[]
}>()

const emit = defineEmits<{
  (e: 'set-active-rectangle-id', id: number): void
  (e: 'duplicate-on-all-pages', item: Rectangle): void
  (e: 'delete-on-all-pages', item: Rectangle): void
  (e: 'delete-rectangle', item: Rectangle): void
}>()

const { t } = useI18n()

// If the area is a copy or the original has copies
const shouldShowDeleteOnAllPages = computed(() => {
  if (props.rectangle.isCopy) return true
  return props.allRectangles.some(
    r => r.index === props.rectangle.index && r.id !== props.rectangle.id,
  )
})
</script>

<style scoped>
.v-list-item:hover {
  background-color: #0B0C0D0D;
}

.delete-rectangle-item {
  color: rgb(var(--v-theme-error)) !important;
}
.delete-rectangle-item:hover {
  background-color: rgb(var(--v-theme-error-lighten-1));
}
</style>
